/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { PencilEditIcon } from '../../../../utils/svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { axiosInstance, classifyPhoneNumber, isEmptyData } from '../../../../utils/helper';
import { apiUrlB2B, timeout } from '../../../../utils/constants';
import { setUser } from '../../../../store/reducers/user';

export const FormProfile = (props) => {
	const { onClose } = props;
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);
	const [isLoading, setIsLoading] = useState(false);

	const userSchema = Yup.object().shape({
		name: Yup.string().required('Name wajib diisi'),
		tanggal: Yup.string().required('Birthday wajib diisi'),
		gender: Yup.string().required('Gender wajib diisi'),
		refferal: Yup.string(),
		telp: Yup.string()
			.required('Nomor Handphone wajib diisi')
			.test('is-mobile-phone', 'Hanya nomor ponsel yang diperbolehkan', (value) => {
				if (!value) return false;
				const result = classifyPhoneNumber(value);
				return result.type === 'mobile';
			}),
		email: Yup.string().email('Format email tidak valid').required('Email wajib diisi'),
	});

	const formik = useFormik({
		initialValues: {
			name: '',
			tanggal: '',
			gender: '',
			refferal: '',
			telp: '',
			email: '',
		},
		validationSchema: userSchema,
		isInitialValid: true,
		onSubmit: async (values) => {
			await handleSave(values);
			onClose?.();
		},
	});

	const { values, errors, touched, isValid, handleChange, handleBlur, handleSubmit, setValues } = formik;

	useEffect(() => {
		setIsLoading(true);
		if (!isEmptyData(user)) {
			setValues((prev) => {
				return { ...prev, name: user?.firstName ?? '', tanggal: user?.birthDate ?? "", gender: user?.gender ?? '', refferal: user?.refferal ?? '', telp: user?.primary_phone ?? '', email: user?.email ?? '' };
			});
		}
		setIsLoading(false);
	}, [user]);

	const handleSave = async (values) => {
		console.log('handleSave');
		try {
			const body = {
				customerFirstName: values?.name,
				customerPhone: values?.telp,
				customerCompanyId: user?.companyID,
				customerEmail: values?.email,
				customerGender: values?.gender,
				customerBirthdate: values?.tanggal,
			};

			dispatch(
				setUser({
					firstName: values?.name,
					primary_phone: values?.telp,
					email: values?.email,
					gender: values?.gender,
					birthDate: values?.tanggal,
					is_b2b: true,
				}),
			);

			const headers = {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${user?.token}`,
			};

			await axiosInstance.put(`customers/${user?.customerID}`, body, { headers, baseURL: apiUrlB2B });
		} catch (error) {
			console.log(error?.response?.data?.message || 'Error in updating user');
		}
	};

	return (
		<div className='m-4'>
			<div className='text-gray-900 font-semibold text-sm mb-4'>Edit Profile</div>
			<div className='mb-4'>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>
					Name <span className='text-xxs text-[var(--pumping-spice)]'>*</span>
				</label>
				<input
					type='text'
					name='name'
					value={values.name}
					placeholder='Name'
					onChange={handleChange}
					onBlur={handleBlur}
					className='!px-0 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !rounded-none'
				/>
				{errors.name && touched.name && <div className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errors.name}</div>}
			</div>
			<div className='mb-4'>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>
					Nomor Handphone <span className='text-xxs text-[var(--pumping-spice)]'>*</span>
				</label>
				<input
					type='text'
					name='telp'
					value={values.telp}
					placeholder='Nomor Handphone'
					onChange={handleChange}
					onBlur={handleBlur}
					className='!px-0 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !rounded-none'
				/>
				{errors.telp && touched.telp && <div className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errors.telp}</div>}
			</div>
			<div className='mb-4'>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>
					Email <span className='text-xxs text-[var(--pumping-spice)]'>*</span>
				</label>
				<input
					type='email'
					name='email'
					value={values.email}
					placeholder='Email'
					onChange={handleChange}
					onBlur={handleBlur}
					className='!px-0 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !rounded-none'
				/>
				{errors.email && touched.email && <div className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errors.email}</div>}
			</div>
			<div className='mb-4'>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>
					Birthday <span className='text-xxs text-[var(--pumping-spice)]'>*</span>
				</label>
				<input
					type='date'
					name='tanggal'
					value={values.tanggal}
					placeholder='Birthday'
					onChange={(e) => {
						const value = e.target.value;
						if (value.length <= 10) {
							setValues((prev) => {
								return { ...prev, tanggal: value };
							});
						}
					}}
					onBlur={handleBlur}
					className='!px-0 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !rounded-none'
				/>
				{errors.tanggal && touched.tanggal && <div className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errors.tanggal}</div>}
			</div>
			<div className='py-4'>
				<div className='text-[var(--dark-gray)] font-semibold text-xxs'>
					Gender <span className='text-xxs text-[var(--pumping-spice)]'>*</span>
				</div>

				<div className='flex gap-4 py-4'>
					<label className='flex items-center gap-2 cursor-pointer'>
						<input
							type='radio'
							name='gender'
							value='M'
							onChange={handleChange}
							onBlur={handleBlur}
							checked={values.gender === 'M'}
							className={`${values.gender === 'M' ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white !focus:ring-0 !focus:bg-transparent !focus:shadow-none`}
						/>
						<span className='text-[var(--dark-gray)] font-semibold text-xxs'>Male</span>
					</label>

					<label className='flex items-center gap-2 cursor-pointer'>
						<input
							type='radio'
							name='gender'
							value='F'
							onChange={handleChange}
							onBlur={handleBlur}
							checked={values.gender === 'F'}
							className={`${values.gender === 'F' ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white !focus:ring-0 !focus:bg-transparent !focus:shadow-none`}
						/>
						<span className='text-[var(--dark-gray)] font-semibold text-xxs'>Female</span>
					</label>
				</div>

				{errors.gender && touched.gender && <div className='text-[var(--pumping-spice)] text-xxs font-medium h-[15px] text-red-500'>{errors.gender}</div>}
			</div>
			<div className='mb-4'>
				<label className='text-[var(--dark-gray)] font-semibold text-xxs'>Reffered (Optional)</label>
				<input
					type='text'
					name='refferal'
					placeholder='Refferal'
					value={values.refferal}
					onChange={handleChange}
					onBlur={handleBlur}
					className='!px-0 focus:outline-none !bg-white focus:!bg-gray-100 w-full disabled:text-gray-400 disabled:opacity-50 !border-b !border-solid !border-steam !rounded-none'
				/>
			</div>
			<button
				type='button'
				onClick={handleSubmit}
				className='capitalize border-none bg-[var(--rose-violet)] disabled:bg-gray-300 text-white w-full py-3 text-center text-xs font-semibold rounded hover:bg-[var(--rose-violet)]/80 transition-all disabled:cursor-not-allowed disabled:opacity-50'
				disabled={isLoading || !isValid}>
				Save
			</button>
		</div>
	);
};

const Form = () => {
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleEditProfile = () => {
		setIsShowBottomSheet(true);
	};

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	return (
		<>
			<div className='border-1 border-solid border-white rounded-full flex px-2.5 py-1.5 items-center gap-1 mr-2 z-5' onClick={handleEditProfile}>
				<PencilEditIcon className='text-white h-4 w-auto' />
				<div className='text-white text-xxs font-semibold'>Edit</div>
			</div>
			<BottomSheet
				key={'form-my-profile'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight];
				}}>
				<FormProfile onClose={handleCloseBottomSheet} />
			</BottomSheet>
		</>
	);
};

export default Form;
